import APIServiceLookUp from './serviceAPI';
import { API_URL, IDP_URL } from './models/AppConstent';

export default class ServiceVerify {
    lookupService = new APIServiceLookUp();

    async verifyToken(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}verifyToken`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async passwordUpdate(body, token) {
        var serviceType = "POST";
        var url = `${IDP_URL}auth/profileVerify`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}